import React from 'react';
import InfoBall from '../InfoBall.js';

class EuroInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inputFocused: false,
      inputValue: this.props.state[this.props.field.stateId],
    };
  }

  onBlur = (e) => {
    this.setState({inputFocused: false}, () => {
      this.setNewValue(Number(this.state.inputValue), true);
    });
    document.getElementById("euro-input-"+this.props.parentIndex+"-"+this.props.index).blur();
  }

  onFocus = (e) => {
    this.setState({
      inputFocused: true,
      inputValue: (this.props.state[this.props.field.stateId]).toFixed(this.props.field.decimals)
    }, () => {
      let elem = document.getElementById("euro-input-"+this.props.parentIndex+"-"+this.props.index);
      elem.focus();
      elem.setSelectionRange(0, 9999);
    });
  }

  handleChange(e) {
    let curVal = e.target.value;
    this.setState({inputValue: curVal}, () => {
      this.setNewValue(curVal, false);
    });
  }

  showDecimalValue(value) {
    if(value === undefined || value === null) return;
    if(!this.state.inputFocused) value = (+value).toFixed(this.props.field.decimals);
    return value.toString().replace(".", ",");
  }

  setNewValue(curVal, happensOnBlur) {
    curVal = curVal.toString().replace(",", ".");
    if(isNaN(curVal)) {
      this.setState({inputValue: this.props.state[this.props.field.stateId]});
      return;
    }
    curVal = Number(Math.round(curVal+'e'+this.props.field.decimals)+'e-'+this.props.field.decimals);
    curVal = (+curVal).toFixed(this.props.field.decimals);
    if(Number(curVal) >= this.props.field.min &&
      Number(curVal) <= this.props.field.max) {
      this.props.updateState({[this.props.field.stateId]: Number(curVal)});
      if(happensOnBlur) this.setState({inputValue: curVal});
    } else
    if(happensOnBlur) {
      if(Number(curVal) < this.props.field.min) {
        this.props.updateState({[this.props.field.stateId]: this.props.field.min});
        this.setState({inputValue: (this.props.field.min).toFixed(this.props.field.decimals)});
      } else
      if(Number(curVal) > this.props.field.max) {
        this.props.updateState({[this.props.field.stateId]: this.props.field.max});
        this.setState({inputValue: (this.props.field.max).toFixed(this.props.field.decimals)});
      }
    }
  }

  render() {
    return <div className="euro-input input-elem">
      <label htmlFor={"euro-input-"+this.props.parentIndex+"-"+this.props.index} className="euro-input__label">
        <span className="euro-input__label-text">{this.props.field.title}</span>
        <span className="euro-input__input-wrapper">
          <input
            className="euro-input__input"
            type="text"
            id={"euro-input-"+this.props.parentIndex+"-"+this.props.index}
            onBlur={(e) => {this.onBlur(e)}}
            onFocus={(e) => {this.onFocus(e)}}
            value={this.showDecimalValue(this.state.inputValue)}
            onKeyPress={(e) => {
              e.persist();
              if(e.key === "Enter") { this.onBlur(); }
            }}
            onChange={this.handleChange.bind(this)}
            maxLength="6" />
          <span className="euro-input__unit">M&euro;</span>
        </span>
      </label>
      {this.props.field.infoText ?
        <InfoBall text={this.props.field.infoText}></InfoBall>
        : null}
    </div>;
  }
}

export default EuroInput;
